import { postingAuditLog } from "@briolin/db";
import type { TestDb } from "@briolin/db/src/testing.js";
import {
  postDocument, unpostDocument,
  type DocRef, type DocTypeValue, type DocumentMovements,
} from "./posting.js";

type Db = TestDb;

export type AuditEntry = { actorId: string; docType: DocTypeValue; docId: string; action: "post" | "unpost" };

export async function recordPosting(db: Db, entry: AuditEntry): Promise<void> {
  await db.insert(postingAuditLog).values({
    actorId: entry.actorId,
    docType: entry.docType,
    docId: entry.docId,
    action: entry.action,
  });
}

// shortcut: аудит-append не в одной транзакции с проведением (спека: «лёгкий аудит-лог»).
// Если понадобится атомарность — перенести recordPosting внутрь транзакции postDocument.
export async function postWithAudit(
  db: Db, actorId: string, ref: DocRef, movements: DocumentMovements,
): Promise<void> {
  await postDocument(db, ref, movements);
  await recordPosting(db, { actorId, docType: ref.docType, docId: ref.docId, action: "post" });
}

export async function unpostWithAudit(
  db: Db, actorId: string, dt: DocTypeValue, docId: string,
): Promise<void> {
  await unpostDocument(db, dt, docId);
  await recordPosting(db, { actorId, docType: dt, docId, action: "unpost" });
}
